(function() {
  'use strict';

angular
  .module('quiz.quizOutro', [])
  .controller('QuizOutroCtrl', QuizOutroCtrl);

  QuizOutroCtrl.$inject = ['$scope', '$routeParams', 'QuizServiceFactory', 'gettext', 'translationService', 'ContentPlayerService'];

  function QuizOutroCtrl($scope, $routeParams, QuizServiceFactory, gettext, translationService, ContentPlayerService) {
    var cModuleId = $routeParams.cModuleId;
    var courseId = $routeParams.courseId;
    var translate = translationService.sprintf;

    $scope.state = {
      canSubmit: false,
      scoreText: '',
      completionText: '',
      passingScoreText: '',
      submittedMessageText: '',
      triesText: '',
      completed: false,
      passed: false,
      currentScorePercent: '',
      customCompletionMessage: '',
      quizTitlePrefix: ''
    };

    var navigation = $scope.navigation;
    var QuizService = QuizServiceFactory.getQuizService(navigation.isPreview);

    navigation.intercept('canNavigate', function interceptCanNavigate(navigateTo) {
      return (navigateTo !== navigation.directions.next || $scope.state.completed || navigation.isPreview);
    });

    $scope.getCurrentScoreClass = function () {
      if ($scope.state.passed || $scope.isPreview)
        return 'scorePassed';

      return 'scoreFailed';
    };

    $scope.submitQuiz = function () {
      if (!$scope.state.canSubmit || $scope.state.completed || navigation.isPreview)
        return;

      $scope.state.canSubmit = false;

      if(navigation.playerType == navigation.playerTypes.trainerAsUserPreview)
        return;

      var submitQuizRequest = {
        cModuleId: cModuleId,
        courseId: courseId,
        quizId: $scope.currentSlide.quizId,
        outroFrameID: $scope.currentSlide.id
      };
      QuizService.submitQuiz(submitQuizRequest, function (result) {
        if (result.frameIsStale)
          return $scope.onStaleFrameFound();

        $scope.setQuizLastSlideInfo(result.quizLastSlideInfo);

        if (result.completionInfo)
          $scope.setCompletionInfo(result.completionInfo);

        $scope.markQuizComplete(result.quizLastSlideInfo.quizId);

        setup();
      });
    };

    var progressStatusWatcher = $scope.$on('$progressProcessingCompleted', quizReady);

    function quizReady() {
      if (!_.isEmpty(ContentPlayerService.serviceStatus))
        return;

      progressStatusWatcher();
      setup();
    }

    function setup() {
      if (!$scope.currentSlide || $scope.currentSlide.__type != 'QuizLastSlideInfo')
        return;

      var quizInfo = $scope.getCurrentQuizInfo();
      if ($scope.isPreview) {
        $scope.state.currentScorePercent = "xx";
      } else {
        $scope.state.currentScorePercent = $scope.currentSlide.currentScorePercent;
      }
      $scope.state.isPreview = $scope.isPreview;
      $scope.state.isPublicCModule = navigation.playerType == navigation.playerTypes.public;
      $scope.state.passed = false;
      $scope.state.customCompletionMessage = quizInfo && _.isString(quizInfo.failedMessage) ?
        quizInfo.failedMessage : '';

      // If the quiz is not setup with a passing score, we might still have a currentScorePercent or
      // a passingScorePercent.
      if ($scope.currentSlide.passed || !$scope.currentSlide.hasPassingScore) {
        $scope.state.passed = true;
        $scope.state.customCompletionMessage = quizInfo && _.isString(quizInfo.passedMessage) ?
          quizInfo.passedMessage : '';
      }

      if (!$scope.state.completed && $scope.currentSlide.hasPassingScore && $scope.state.currentScorePercent >= $scope.currentSlide.passingScorePercent) {
        $scope.state.passed = true;
      }

      if ($scope.currentSlide.completed)
        return setCompleteState();

      return setIncompleteState();
    }

    function setCompleteState() {
      $scope.state.completed = true;
      $scope.state.canSubmit = false;
      $scope.state.quizTitlePrefix = gettext('Quiz Recap:');
      $scope.state.submittedMessageText = gettext("Sorry, you didn't pass this quiz; your final score is");

      if (!$scope.currentSlide.hasPassingScore) {
        $scope.state.submittedMessageText = gettext("Thank you. You completed this quiz with a final score of");
        return;
      }
      if ($scope.state.passed) {
        $scope.state.submittedMessageText = gettext("Congratulations, you passed this quiz with a final score of");
        return;
      }
    }

    function setIncompleteState() {
      $scope.state.completed = false;
      $scope.state.canSubmit = true && !navigation.isPreview;
      $scope.state.quizTitlePrefix = gettext('Quiz:');
      $scope.state.completionText = gettext("You've completed all of the questions in this quiz.");
      $scope.state.triesText = gettext('Click the Submit Quiz button to continue.');

      if ($scope.currentSlide.hasPassingScore) {
        $scope.state.passingScoreText = translate(gettext('(the passing score for this quiz is'));
        $scope.state.passingScoreText += " " + $scope.currentSlide.passingScorePercent;
        $scope.state.passingScoreText += "%).";
      }
      else {
        $scope.state.passingScoreText += ".";
      }

      if ($scope.currentSlide.questionAttemptsLeft == -1 || $scope.currentSlide.questionAttemptsLeft > 0) {
        $scope.state.triesText = gettext('There are some questions that you can try again. Navigate back to retry these ' +
          'questions or click the Submit Quiz button below.');
      }
    }

    quizReady();
  }
})();
